<template>
  <div id="add-profession">
    <v-card class="add-lom-card elevation-6">
      <v-app-bar
        color="transparent"
        dense
        dark
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
        class="add-lom-appbar"
      >
        <v-toolbar-title class="title-wrap">
          <v-icon class="mr-2" color="white">mdi-upload</v-icon>
          <span>{{ pageTitle }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon dark @click="closePrompt" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text class="card-body">
        <v-form ref="form1" v-model="valid1" lazy-validation id="createForm">
          <v-row>
            <v-col cols="12">
              <div class="instructions-box">
                <div class="instructions-title">Upload File Instructions</div>
                <ul class="instructions-list">
                  <li>The DIS form must be filled and signed by the IPP.</li>
                  <li>
                    The filled DIS form can be uploaded in any file format (PDF, Word, Image, Excel, etc.).
                  </li>
                  <li>The file size should not exceed 2 MB.</li>
                </ul>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="old-docs-row"
            v-if="recordData && recordData.LomDocumentPathArray"
          >
            <v-col cols="12" class="text-center">
              <div class="old-docs-heading">Existing Documents</div>
              <div
                v-if="recordData.LomDocumentPathArray && recordData.LomDocumentPathArray.length > 0"
                class="document-links"
              >
                <v-list dense class="pa-0 document-list">
                  <v-list-item
                    v-for="(row, index) in recordData.LomDocumentPathArray"
                    :key="index"
                    class="document-list-item"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon color="primary">mdi-file-pdf-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="document-link">
                        <a
                          :href="row"
                          target="_blank"
                          class="text-decoration-none"
                        >
                          Directory Information Document {{ index + 1 }}
                        </a>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        icon
                        small
                        color="primary"
                        :href="row"
                        target="_blank"
                        class="download-btn"
                      >
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </div>
              <div v-else class="no-old-docs caption">
                No previous documents uploaded.
              </div>
            </v-col>
          </v-row>

          <v-row class="upload-row">
            <v-col cols="12" sm="8" md="6" lg="4" class="mx-auto">
              <v-file-input
                :clearable="false"
                truncate-length="30"
                placeholder="Select file (max 2MB)"
                v-model="UploadedFile1"
                prepend-icon="mdi-file-document"
                outlined
                dense
                class="file-input-custom"
              >
                <template v-slot:append-outer>
                  <v-icon
                    color="red"
                    @click="UploadedFile1 = {}"
                    class="delete-icon"
                    >mdi-delete</v-icon
                  >
                </template>
              </v-file-input>

              <div class="helper-row d-flex justify-space-between mt-2">
                <div class="helper-note caption">Any file type • Max 2MB</div>
                <div
                  v-if="UploadedFile1 && UploadedFile1.name"
                  class="file-name caption"
                >
                  {{ UploadedFile1.name }}
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="actions-row">
            <v-col cols="12" class="text-center">
              <v-btn
                :disabled="!valid1 || !UploadedFile1 || !UploadedFile1.name"
                @click.prevent="confirmAlert"
                :loading="SubmitFlag"
                elevation="8"
                rounded
                color="primary"
                class="save-btn white--text"
              >
                <v-icon left>mdi-content-save</v-icon>
                Save
              </v-btn>

              <v-btn
                @click="closePrompt"
                elevation="8"
                rounded
                outlined
                color="grey"
                class="close-action-btn ml-4"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>

          <upload-progress
            :ProgessStart="progessStart"
            :UploadPercentage="uploadPercentage"
          ></upload-progress>
        </v-form>
      </v-card-text>

      <v-card-actions class="card-footer">
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
    recordData: {
      required: true,
    },
    UserInterface: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      DisDocumentFlag: false,
      UploadFlag: false,

      LomId: "",
      MemberId: "",
      progessStart: 0,
      uploadPercentage: 0,

      rows: [],
      member: {},
      OldDocumentFlag: false,

      UploadedFile1: {},

      DocumentTypeRules: [(v) => !!v || "Document Type is required"],
      DocumentType: "",
      DocumentTypeOptions: [],
      DocumentTypeOptionsLoading: false,

      ReferenceNo: "",
      ReferenceNoRules: [(v) => !!v || "Reference No is required"],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    resetUploadFile() {
      console.log("resetUploadFile called.");
      this.UploadFile = {};
    },
    closePrompt() {
      console.log("closePrompt called");
      // this.$emit('Member', this.NewMember);
      this.$emit("hideAddRecordPrompt", this.DisDocumentFlag);
    },
    refreshPageData() {
      console.log("refreshPageData add lom document called");
      var record = this.recordData;
      console.log({ record });

      this.LomId = record.LOMId;
      this.MemberId = record.MemberId;
      console.log("lomid" + this.LomId);
      console.log("MemberId" + this.MemberId);
      this.getTableRecords();
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      
      if (!this.UploadedFile1 || !this.UploadedFile1.name) {
        this.sweetAlert("error", "Please select a file before saving", false);
        return;
      }
      
      if (validate1) {
        Swal.fire({
          title: "Confirm Upload?",
          text: `Are you sure you want to upload "${this.UploadedFile1.name}"?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: `Yes, Upload`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("info", "Upload cancelled", false);
          }
        });
      } else {
        this.sweetAlert("error", "Kindly fill the required fields", false);
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var validate = true;

      if (validate) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-document/show";
        var upload = {
          UserInterface: 1,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);

            thisIns.OldDocumentFlag = flag;

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));

              thisIns.rows = records;

              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      }
    },
    submitForm() {
      console.log("submitForm called");
      var validate1 = this.$refs.form1.validate();
      // var validate1 = true;
      console.log("validate1=" + validate1);
      var message = "";

      if (validate1) {
        var form = {
          Lom: this.LomId,
          Member: this.MemberId,
        };

        let upload = new FormData();
        upload.append("UserInterface", this.UserInterface);
        upload.append("Form", JSON.stringify(form));
        upload.append("uploadFile1", this.UploadedFile1);

        console.log("upload=" + JSON.stringify(upload));

        this.SubmitFlag = true;
        this.progessStart = 1;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-document/store";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        console.log("upload=" + JSON.stringify(upload));

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.DisDocumentFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.resetForm();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill required fields.";
        }
        if (!uploadFile1) {
          message += "File is not selected";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
    this.member = {};
  },
};
</script>
<style lang="scss">
#add-profession {
  .add-lom-card {
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(180deg, #ffffff, #fbfdff);
  }

  .add-lom-appbar {
    background: linear-gradient(90deg, #2b6be6 0%, #4e8ef7 100%) !important;
    color: #fff;
    .v-toolbar__content {
      padding-left: 16px;
    }
  }

  .title-wrap {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 0.2px;
  }

  .card-body {
    padding: 20px !important;
  }

  .instructions-box {
    background: linear-gradient(180deg, #f7f9ff, #ffffff);
    border: 1px solid rgba(46, 108, 230, 0.08);
    padding: 14px;
    border-radius: 8px;
    margin-bottom: 12px;

    .instructions-title {
      font-weight: 700;
      color: #1f2937;
      margin-bottom: 8px;
    }

    .instructions-list {
      margin: 0;
      padding-left: 18px;
      color: #54606a;
      font-size: 14px;
      li {
        margin-bottom: 6px;
      }
    }
  }

  .old-docs-row {
    margin-top: 8px;
    .old-docs-heading {
      font-weight: 700;
      color: #263238;
      margin-bottom: 8px;
    }
    .no-old-docs {
      color: #6b7280;
      margin-top: 6px;
    }
    .document-list-item {
      border-radius: 6px;
      padding: 6px 8px;
      transition: background 0.12s;
      &:hover {
        background: rgba(46, 108, 230, 0.03);
      }
    }
  }

  .upload-row {
    margin-top: 10px;
  }

  .file-input-custom {
    background: #fff;
    border-radius: 8px;
  }

  .helper-row {
    margin-top: 6px;
    color: #6b7280;
    .file-name {
      color: #1f2937;
    }
  }

  .actions-row {
    margin-top: 18px;
    .save-btn {
      background: linear-gradient(90deg, #2b6be6, #4e8ef7) !important;
      min-width: 140px;
      font-weight: 700;
    }
    .close-action-btn {
      min-width: 120px;
      border-radius: 8px;
    }
  }

  .card-footer {
    padding: 12px 20px;
    background: transparent;
  }

  .delete-icon {
    cursor: pointer;
  }

  /* Responsive */
  @media (max-width: 600px) {
    .file-input-custom {
      width: 100%;
    }
    .save-btn {
      width: 120px;
    }
  }
}
</style>
// ...existing code...